var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"simulation-banner"},[_vm._v(" "+_vm._s(_vm.translate('Controls.text13'))+" "),_c('router-link',{staticClass:"scenario-route",attrs:{"to":"/scenarios"}},[_vm._v(_vm._s(_vm.translate('Controls.text14')))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }